module.exports = __webpack_public_path__ + "img/swap_2.3e8dc1ce.svg";